import { useEffect } from 'react';

export function useKeyboardEvent(
    key: KeyboardEvent['key'],
    callback: () => void
) {
    useEffect(() => {
        const eventListener = (e: KeyboardEvent) => {
            if (e.key === key) {
                callback();
            }
        };
        window.addEventListener('keydown', eventListener);
        return () => {
            window.removeEventListener('keydown', eventListener);
        };
    }, []);
}
